import React from 'react';
import {
  Box, Tooltip, Typography,
} from '@mui/material';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../../theme';
import { ActiveBuildOverride } from '../../utils/api-base-url';

interface BuildOverrideIndicatorProps {
  // Mirrors the sidebar drawer's expanded state so the label shows only when there is room.
  open: boolean;
  // The active gql-api build override, or null when the default API URL is in use.
  override: ActiveBuildOverride | null;
}

const BuildOverrideIndicator: React.FC<BuildOverrideIndicatorProps> = ({ open, override }) => {
  const { t } = useTranslation('components', { keyPrefix: 'build-override-indicator' });

  if (!override) {
    return null;
  }

  return (
    <Tooltip
      arrow={true}
      placement='right'
      title={t('tooltip', {
        build: override.label,
        url: override.url,
      })}
    >
      <Box
        data-testid='build-override-indicator'
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mx: open ? 2 : 'auto',
          my: 1.5,
          px: open ? 1.5 : 0,
          py: 0.75,
          borderRadius: 1,
          justifyContent: open ? 'flex-start' : 'center',
          color: COLORS.darkOrange,
          backgroundColor: COLORS.backgroundYellow,
          cursor: 'default',
        }}
      >
        <ScienceOutlinedIcon sx={{ fontSize: '1.25rem' }} />
        <Typography
          data-testid='build-override-indicator-label'
          sx={{
            fontWeight: 'bold',
            fontSize: '0.8125rem',
            whiteSpace: 'nowrap',
            opacity: open ? 1 : 0,
            width: open ? 'auto' : 0,
            overflow: 'hidden',
          }}
        >
          {t('label', { build: override.label })}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default BuildOverrideIndicator;
